module.exports = __webpack_public_path__ + "img/quick_sell.70bf811f.svg";